import api from "../api";

export const addWalkInStudent = (role, data) =>
  api.post(`/${role.toLowerCase()}/session-participants`, data);

export const getWalkInsBySession = (role, sessionId) =>
  api.get(`/${role.toLowerCase()}/session-participants/session/${sessionId}`);

export const getWalkInsByStudent = (role, studentId) =>
  api.get(`/${role.toLowerCase()}/session-participants/student/${studentId}`);

export const removeWalkInStudent = (role, sessionId, studentId) =>
  api.delete(
    `/${role.toLowerCase()}/session-participants/session/${sessionId}/student/${studentId}`,
  );
